<template>
  <div v-if="botAssets?.positions" class="table-responsive scrollbar">
    <table class="table table-hover table-sm table-striped fs-10 mb-0 overflow-hidden">
      <thead class="bg-200">
        <tr>
          <th class="text-900 align-middle white-space-nowrap">Asset</th>
          <th class="text-900 align-middle white-space-nowrap">Leverage</th>
          <th class="text-900 align-middle white-space-nowrap">Direction</th>
          <th class="text-900 align-middle white-space-nowrap">Collateral</th>
          <th class="text-900 align-middle white-space-nowrap text-center_">Unrealized P&L</th>
        </tr>
      </thead>
      <tbody class="list">
        <tr v-if="botAssets.positions?.length <= 0" class="">
          <td colspan="5" class="py-2 align-middle white-space-nowrap text-center">
            <span>No positions found</span>
          </td>
        </tr>
        <tr v-for="position in botAssets.positions" :key="position" class="">
          <td class="pe-3 py-2 align-middle white-space-nowrap">
            <span class="fw-bold">{{ position.baseCoin }}</span>
          </td>
          <td class="py-2 align-middle white-space-nowrap">
            {{ position.leverage }}x
          </td>
          <td class="py-2 align-middle white-space-nowrap">
            {{ position.direction }}
          </td>
          <td class="py-2 align-middle white-space-nowrap">
            {{ getPrettyFloatNumber(position.currentCollateralAsQuoteCoin) }} {{ position.quoteCoin }}
          </td>
          <td class="py-2 align-middle white-space-nowrap text-center_">
            {{ getPrettyFloatNumber(position.unrealizedPnlAsQuoteCoin, 4) }} {{ position.quoteCoin }} ({{ getPrettyFloatNumber(position.unrealizedPnlAsPercentage, 4) }}%)
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    botAssets: {
      required: true,
      type: Object
    }
  },
  computed: {
    protectPrivacy () {
      return this.$store.getters.getProtectPrivacy
    }
  },
  methods: {
    getPrettyFloatNumber (number, numDecimals) {
      let formattedNumber = parseFloat(number).toLocaleString('en-US', {minimumFractionDigits: numDecimals, maximumFractionDigits: numDecimals})

      if (this.protectPrivacy) {
        formattedNumber = 'x.xxxx'
      }

      return formattedNumber
    },
  },
  async created () {
  }
}
</script>

<style scoped>
.table tr td {
  border-style: none;
}
</style>